// extracted by mini-css-extract-plugin
export default {"button":"MessageOption_button__2qe+T","buttonFeatured":"MessageOption_buttonFeatured__rx+gc"};